<template>
  <b-card>
    <p class="mb-0" v-if="item.cyclicTask">
      <b-badge variant="danger">{{$t('views.excmcase.list.cyclicTask')}}</b-badge>
    </p>
    <b-row align-v="start">
      <b-col lg="9" sm="6">
        <span v-if="item.number" class="h5"><b> ID - {{ item.number  + ' ' + item.contractorUserData.firmname1 + ' ' + item.contractorUserData.fullName }} </b></span>
        <span v-else class="h5"><b> ID - {{ item.id  + ' ' + item.contractorUserData.firmname1 + ' ' + item.contractorUserData.fullName }} </b></span>
      </b-col>
      <b-col class="text-right" lg="3" sm="6">
        <h6><span v-if="item.idPriority" class="badge" :style="'color: ' + item.idPriority.textColor + '; background-color: ' + item.idPriority.backgroundColor">{{item.idPriority.title}}</span></h6>
      </b-col>
    </b-row>
    <p class="mt-2" v-if="item.lastTask && item.lastTask.idTaskType"><b>{{$t('views.excmcase.show.currentTask')}}: </b>{{item.lastTask.idTaskType.title}}</p>
    <p v-else> {{$t('views.excmcase.list.noTasks')}}</p>
    <p v-if="item.createdAt"><b>{{$t('views.excmcase.show.created')}}: </b><span>{{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}</span></p>
    <p v-if="item.contractorUserData"><b>{{$t('views.excmagreements.show.company')}}: </b>
      <router-link :to="{name: 'FirmShow', params: { id: item.contractorUserData['@id'] }}">
        <span v-if="item.contractorUserData.firmname1">{{item.contractorUserData.firmname1}}</span>
        <span v-if="item.contractorUserData.fullName">{{item.contractorUserData.fullName}}</span>
      </router-link>
    </p>
    <p v-if="item.contractorUserData.firmname1"><b>{{$t('views.userdata.show.userDataFirm.firmname')}}: </b>{{item.contractorUserData.firmname1 || item.contractorUserData.fullName}}</p>
    <p v-if="item.contractorUserData.fullAddress && item.contractorUserData.fullAddress !== '  '"><b>{{$t('views.userdata.show.adress')}}: </b>{{item.contractorUserData.fullAddress}}</p>
    <p v-if="item.contractorUserData.userEmail"><b>{{$t('views.userdata.form.userEmail')}}: </b><a :href="'mailto: ' + item.contractorUserData.userEmail">{{item.contractorUserData.userEmail}}</a></p>
    <p v-if="item.contractorUserData.contactEmail"><b>{{$t('views.userdata.form.contactEmail')}}: </b><a :href="'mailto: ' + item.contractorUserData.contactEmail">{{item.contractorUserData.contactEmail}}</a></p>
    <p v-if="item.contractorUserData.mobilePhone && item.contractorUserData.mobilePhone !== ' ' && item.contractorUserData.mobilePhone !== '+48'"><b>{{$t('views.userdata.form.mobilePhone')}}: </b> <phoneNumberLink :phoneNumber="item.contractorUserData.mobilePhone"/></p>
    <template v-if="item.contractorUserData.userDataAddresses.length > 0">
      <hr class="my-1">
      <template v-for="(address, addressIndex) in item.contractorUserData.userDataAddresses">
        <div v-bind:key="'address-' + addressIndex">
          <hr class="my-1" v-if="addressIndex !== 0">
          <p><b>{{$t('views.userdata.form.addressType')}}: </b>{{ getAddressTypeTitle(address.addressType) }}</p>
          <p v-if="address.city"><b>{{$t('views.userdata.show.userDataFirm.city')}}: </b>{{address.city}}</p>
          <p v-if="address.street"><b>{{$t('views.userdata.show.userDataFirm.street')}}: </b>{{address.street}}</p>
          <p v-if="address.streetNumber"><b>{{$t('views.userdata.form.streetNumber')}}: </b>{{address.streetNumber}}</p>
          <p v-if="address.placeNumber"><b>{{$t('views.userdata.form.placeNumber')}}: </b>{{address.placeNumber}}</p>
          <p v-if="address.postcode"><b>{{$t('views.userdata.show.userDataFirm.postcode')}}: </b>{{address.postcode}}</p>
          <p v-if="address.province"><b>{{$t('views.userdata.show.userDataFirm.province')}}: </b>{{address.province}}</p>
          <p v-if="address.country"><b>{{$t('views.userdata.show.userDataFirm.country')}}: </b>{{address.country}}</p>
        </div>
      </template>
    </template>
    <div v-if="item.customFields.length > 0">
      <div v-for="(customField, fieldIndex) in item.customFields" :key="fieldIndex" >
        <template v-if="!isRoleDisabled(customField) && customField.value">
          <p v-if="customField.type === 'datetime'"><b>{{customField.label}}: </b><span v-if="$moment(customField.value).isValid()">{{$moment(customField.value).format('YYYY-MM-DD')}}</span></p>
          <p v-else-if="customField.type === 'multiSelect' && Array.isArray(customField.value) && customField.value.length > 0"><b>{{customField.label}}: </b>{{customField.value.join(', ')}}</p>
          <p v-else-if="customField.type === 'inputFormatted'"><b>{{customField.label}}: </b><span v-html="customField.value"></span></p>
          <items-collection-custom-field-values v-else-if="customField.type === 'itemsCollection'" :data="customField"></items-collection-custom-field-values>
          <id-user-data-custom-field-value v-else-if="customField.type === 'idUserData'" :data="customField"></id-user-data-custom-field-value>
          <p v-else><b>{{customField.label}}: </b>{{customField.value}}</p>
        </template>
      </div>
    </div>
    <hr class="my-1">
    <p v-if="item.ownerUserData">
      <b>{{$t('views.excmcase.form.ownerUserData')}}</b>:
      {{ item.ownerUserData.firmname1 === '' ? item.ownerUserData.fullName : item.ownerUserData.firmname1 }}
      <span v-if="item.ownerUserData.contactEmail"><a :href="'mailto: ' + item.ownerUserData.contactEmail">{{item.ownerUserData.contactEmail}}</a></span>
      <span v-if="item.ownerUserData.userEmail"><a :href="'mailto: ' + item.ownerUserData.userEmail">{{item.ownerUserData.userEmail}}</a></span>
    </p>
    <p v-if="item.partnerUserData">
      <b>{{$t('views.excmcasetype.form.enablePartner')}}</b>:
      {{ item.partnerUserData.firmname1 === '' ? item.partnerUserData.fullName : item.partnerUserData.firmname1 }}
      <span v-if="item.partnerUserData.contactEmail"><a :href="'mailto: ' + item.partnerUserData.contactEmail">{{item.partnerUserData.contactEmail}}</a></span>
      <span v-if="item.partnerUserData.userEmail"><a :href="'mailto: ' + item.partnerUserData.userEmail">{{item.partnerUserData.userEmail}}</a></span>
    </p>
      <b-row>
        <b-col cols="12">
          <div v-if="item.description"><p class="h6"><b>{{$t('global.description')}}: </b></p><p>{{ item.description }}</p></div>
          <p v-if="item.idRelatedCorrespondenceMessage">
            <b>{{$t('tableHeadings.idRelatedCorrespondenceMessage')}}</b>:
            <router-link :to="{name: 'EXCMCorrespondenceThreadShow', params: { id: item.idRelatedCorrespondenceMessage.idThread['@id'] }}">
              {{ item.idRelatedCorrespondenceMessage.idThread.subject }}
            </router-link>
          </p>
        </b-col>
        <b-col cols="12">
          <div v-if="visibleCaseManage">
            <button type="button" class="btn btn-success btn-sm" v-b-tooltip.hover :title="$t('buttons.edit')" @click="editCase(item)" v-if="ableToEditCase && getIdLink(item.status['@id']) === '1'">
              <i class="fa fa-pencil"></i>
            </button>
            <button type="button" class="btn btn-danger btn-sm"  v-b-tooltip.hover :title="$t('buttons.closeCase')" @click="closeCase(item)" v-if="getIdLink(item.status['@id']) === '1'">
              <i class="fa fa-times"></i>
            </button>
            <template v-if="getIdLink(item.status['@id']) === '2'">
              <b-btn v-if="ableToRevertActions" size="sm" @click="openCase()">{{$t('buttons.openAgain')}}</b-btn>
              <router-link v-if="item.settlement" :to="{ name: 'EXSBSettlementShow', params: { id: item.settlement } }" class="btn btn-success btn-sm">
                {{$t('buttons.goToSettle')}}
              </router-link>
              <b-button v-else size="sm" variant="success" @click="settleCase(item)">
                {{$t('buttons.settle')}}
              </b-button>
            </template>
          </div>
          <button v-if="ableToDownloadCasePdf" type="button" class="btn btn-success btn-sm" @click="downloadCasePdf(item)"><i class="fa fa-download"></i> {{$t('buttons.downloadCasePdf')}}</button>
        </b-col>
      </b-row>
  </b-card>
</template>

<script>
import getId from '../../../../../utils/getIdFromLink'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
// import { ENTRYPOINT } from '@/config/entrypoint'
import { mapGetters } from 'vuex'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'
import ItemsCollectionCustomFieldValues from '@/components/Dashboard/Views/excmcase/components/itemsCollectionCustomFieldValues.vue'
import IdUserDataCustomFieldValue from '@/components/Dashboard/Views/excmcase/components/idUserDataCustomFieldValue.vue'

export default {
  name: 'CaseHeader',
  components: { IdUserDataCustomFieldValue, ItemsCollectionCustomFieldValues, PhoneNumberLink },
  data () {
    return {
      isDetailsVisible: false
    }
  },
  computed: {
    ableToEditCase () {
      return checkPermission('cases', 'EXCMCaseUpdate')
    },
    ableToDownloadCasePdf () {
      return true
    },
    ...mapGetters({
      getAddressTypeTitle: 'userdataaddress/list/getAddressTypeText'
    })
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    visibleCaseManage: {
      required: true
    },
    ableToRevertActions: {
      required: true
    }
  },
  methods: {
    getIdLink (link) {
      return getId(link)
    },
    closeCase (item) {
      this.$emit('closeCase', item)
    },
    editCase (item) {
      this.$emit('editCase', item)
    },
    openCase (item) {
      this.$emit('openCase', item)
    },
    settleCase (item) {
      this.$emit('settleCase', item)
    },
    downloadCasePdf (item) {
      let id = getId(item['@id'])
      if (item.number) {
        id = item.number
      }
      new ApiService(item['@id'] + '/pdf').downloadFile(this.$t('routes.EXCMCaseShow') + ' ' + id + ' / ' + this.$moment(item.createdAt).format('Y'))
    },
    isRoleDisabled (customField) {
      if (customField.disabledRoles && customField.disabledRoles.length > 0) {
        let idClientType = getUserRoles().id_client_type
        if (customField.disabledRoles.includes(idClientType)) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped>
  .table > tbody > tr > td {
    padding: 2px !important;
  }
</style>
